import React from "react";
import pluralize from "pluralize";
import {
    StandardModal,
    StandardModalActionButton,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalFormGrid,
    StandardModalFormGroup,
    StandardModalInput,
    StandardModalLabel,
    StandardModalSection,
    StandardModalSectionTitle
} from "src/components";

const USER_FORM_SUCCESS_MODAL_WIDTH = "min(56.25rem, calc(100vw - 2rem))";

const UserFormSuccessModal = (props) => {
    const { showDialog, handleClose, openSendInviteForm, user, isUserNewlyCreated, title, customNames } = props;

    const handlePreInvite = () => {
        openSendInviteForm([user]);
    };

    const userTypeName = user.isClient
        ? pluralize.singular(customNames?.clients || "Clients")
        : pluralize.singular(customNames?.employees || "Employees");
    const modalTitle = title || `New ${userTypeName} Added Successfully!`;

    return (
        <StandardModal
            open={showDialog}
            onClose={handleClose}
            title={modalTitle}
            widthMode={USER_FORM_SUCCESS_MODAL_WIDTH}
            footer={(
                <StandardModalActionGroup $center>
                    <StandardModalActionButton width="9.75rem" onClick={handleClose}>
                        {!isUserNewlyCreated ? "Done" : "Send Invite Later"}
                    </StandardModalActionButton>
                </StandardModalActionGroup>
            )}
        >
            <StandardModalSection>
                <StandardModalSectionTitle>User Details</StandardModalSectionTitle>
                <StandardModalFormGrid columns="repeat(3, minmax(0, 1fr))">
                    <StandardModalFormGroup>
                        <StandardModalLabel>First Name</StandardModalLabel>
                        <StandardModalInput value={user.firstName || ""} readOnly style={{ textTransform: "capitalize" }} />
                    </StandardModalFormGroup>
                    <StandardModalFormGroup>
                        <StandardModalLabel>Last Name</StandardModalLabel>
                        <StandardModalInput value={user.lastName || ""} readOnly style={{ textTransform: "capitalize" }} />
                    </StandardModalFormGroup>
                    <StandardModalFormGroup>
                        <StandardModalLabel>Email</StandardModalLabel>
                        <StandardModalInput value={user.email || ""} readOnly />
                    </StandardModalFormGroup>
                </StandardModalFormGrid>
            </StandardModalSection>

            {isUserNewlyCreated && (
                <StandardModalSection>
                    <StandardModalSectionTitle>Send App Invite?</StandardModalSectionTitle>
                    <StandardModalDescription>
                        Would you like to send an app invite to this user now? You can also send app invites later through the User Invite column in My User Lists.
                    </StandardModalDescription>
                    <StandardModalActionGroup $pushRight>
                        <StandardModalActionButton $variant="primary" type="button" onClick={handlePreInvite}>
                            Send Invite
                        </StandardModalActionButton>
                    </StandardModalActionGroup>
                </StandardModalSection>
            )}
        </StandardModal>
    );
};

export default UserFormSuccessModal;
